import React from "react";
import moment from "moment";
import Modal from "react-responsive-modal";
import DatePicker from "react-datepicker";
import { Controller } from "react-hook-form";
import LoadMask from "Utils/LoadMask/LoadMask";
import Paginacion from "Utils/Components/Paginacion/Paginacion";
import { useHistorialDesfaseReloj } from "../../hooks/useHistorialDesfaseReloj";
import { RelojVivo } from "./RelojVivo";
import { HistorialDesfaseTable } from "./HistorialDesfaseTable";
import { DESCRIPCIONES_RELOJ, NOMBRES_RELOJ } from "./contextosReloj";

export const ModalDesfaseReloj = ({ reloj }) => {
    const {
        contexto,
        modalAbierto,
        CerrarModal,
        formRegister,
        formControl,
        errors,
        cambiarFecha,
        fechaUltimoCierreBodega,
        cierreBodegaPosteriorAFechaElegida,
        GuardarCambio,
        cargando,
    } = reloj;

    const historial = useHistorialDesfaseReloj({
        contexto,
        opened: modalAbierto,
    });

    const idCheck = `cambiar_fecha_reloj_${contexto}`;

    return (
        <Modal
            open={modalAbierto}
            onClose={CerrarModal}
            closeOnOverlayClick={false}
            focusTrapped={false}
        >
            <LoadMask loading={cargando || historial.cargando} blur>
                <h4 className="text-center mb-2">{NOMBRES_RELOJ[contexto]}</h4>

                <p className="mb-3">{DESCRIPCIONES_RELOJ[contexto]}</p>

                <form onSubmit={GuardarCambio}>
                    <div
                        className="formulario-fields-row my-0"
                        style={{ maxWidth: "400px" }}
                    >
                        <div className="formulario-field">
                            <label className="text-nowrap">
                                Fecha y hora{" "}
                                {cambiarFecha ? "(Manual)" : "(Actual)"}
                            </label>
                            {cambiarFecha ? (
                                <Controller
                                    name="fecha_hora_configurada"
                                    control={formControl}
                                    rules={{
                                        required:
                                            "Debe indicar la fecha y hora del reloj",
                                    }}
                                    render={({ field }) => {
                                        // no puede ser futura: en el día de
                                        // hoy la hora se limita hasta este
                                        // momento. El datepicker exige minTime
                                        // junto con maxTime
                                        const esHoy =
                                            field.value &&
                                            moment(field.value).isSame(
                                                moment(),
                                                "day",
                                            );

                                        return (
                                            <DatePicker
                                                selected={field.value}
                                                onChange={field.onChange}
                                                showTimeSelect
                                                timeFormat="HH:mm"
                                                showPopperArrow={false}
                                                dateFormat="DD/MM/YYYY HH:mm"
                                                placeholderText="Fecha y hora del reloj"
                                                maxDate={moment()}
                                                minTime={moment().startOf(
                                                    "day",
                                                )}
                                                maxTime={
                                                    esHoy
                                                        ? moment()
                                                        : moment().endOf("day")
                                                }
                                            />
                                        );
                                    }}
                                />
                            ) : (
                                <RelojVivo diferenciaMs={0} esTiempoActual />
                            )}
                            {cambiarFecha && errors.fecha_hora_configurada && (
                                <small className="text-danger">
                                    {errors.fecha_hora_configurada.message}
                                </small>
                            )}
                        </div>
                        <div className="reloj-desfase__check">
                            <input
                                type="checkbox"
                                className="checkbox"
                                id={idCheck}
                                {...formRegister("cambiar_fecha")}
                            />
                            <label
                                htmlFor={idCheck}
                                className="m-0 pl-0 text-nowrap"
                            >
                                Cambiar fecha y hora
                            </label>
                        </div>
                    </div>

                    {cierreBodegaPosteriorAFechaElegida && (
                        <div className="alert alert-warning text-center mt-3 mb-0">
                            {"Bodega de producción ya registró cierres de " +
                                "inventario hasta el " +
                                moment(fechaUltimoCierreBodega).format(
                                    "DD/MM/YYYY HH:mm",
                                ) +
                                ". No es correcto registrar movimientos con " +
                                "fechas anteriores."}
                        </div>
                    )}

                    <div className="d-flex gap-10 mt-3 mb-2 align-items-center">
                        <p className="reloj-desfase__aviso flex-1 mt-0">
                            Al guardar, la pantalla se volverá a cargar y se
                            perderán los datos que no se hayan guardado.
                        </p>
                        <div className="d-flex justify-content-center gap-10">
                            <button
                                type="button"
                                className="btn btn-outline-dark"
                                onClick={CerrarModal}
                            >
                                Regresar
                            </button>
                            <button type="submit" className="btn btn-primary">
                                Guardar
                            </button>
                        </div>
                    </div>
                </form>

                <h5 className="mt-4 mb-0">Historial de cambios</h5>

                <HistorialDesfaseTable historial={historial} />

                <Paginacion
                    cantidadResultados={historial.cantidadResultados}
                    paginaSeleccionada={historial.paginaSeleccionada}
                    setPaginaSeleccionada={historial.setPaginaSeleccionada}
                />
            </LoadMask>
        </Modal>
    );
};
